import { render } from "./CuestionarioPersonal.vue?vue&type=template&id=785a6a8d&scoped=true"
import script from "./CuestionarioPersonal.vue?vue&type=script&lang=js"
export * from "./CuestionarioPersonal.vue?vue&type=script&lang=js"

import "./CuestionarioPersonal.vue?vue&type=style&index=0&id=785a6a8d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a6a8d"]])

export default __exports__